import http from "@/shared/services/http";
import {PostOfficeParams} from "@/modules/postoffices/params";

export const createPostOffice = (data: any) => http.post(`v1/post-offices`, data);
export const listPostOffice = (params: PostOfficeParams) => http.get(`v1/post-offices`, { params });
export const singlePostOffice = (id: string) => http.get(`v1/post-offices/${id}`);
export const updatePostOffice = (id: string, data: any) => http.put(`v1/post-offices/${id}`, data);
export const deletePostOffice = (id: string) => http.delete(`v1/post-offices/${id}`);